import { Routes } from '@angular/router';
import { MainViewComponent } from './components/main-view/main-view.component';
import { InvalidLinkViewComponent } from './components/invalid-link-view/invalid-link-view.component';
import { SuccessViewComponent } from './components/success-view/success-view.component';
import { AdViewComponent } from './components/ad-view/ad-view.component';

export const routes: Routes = [
  {
    path: 'ad/:jobId',
    pathMatch: 'full',
    component: AdViewComponent,
  },
  {
    path: 'form/:jobId',
    pathMatch: 'full',
    component: MainViewComponent,
  },
  {
    path: 'success',
    pathMatch: 'full',
    component: SuccessViewComponent,
  },
  {
    path: 'invalid-link',
    pathMatch: 'full',
    component: InvalidLinkViewComponent,
  },
  {
    path: '**',
    redirectTo: 'invalid-link',
  },
];
